<template>
  <thead>
    <tr class="cusmtom-thead-color">
      <td
        class="text-center custom-header-label"
        rowspan="3"
        style="padding-top: 17px; width: 5%"
      >
        {{ $t('common_words.farm') }}
      </td>
      <td
        class="text-center custom-header-label"
        rowspan="3"
        style="padding-top: 17px; width: 5%"
      >
        {{ $t('common_words.age') }}
      </td>
      <td
        class="text-center custom-header-label"
        colspan="4"
        style="width: auto"
      >
        {{ $t('production.weight') }} (Kg)
      </td>
      <td
        class="text-center custom-header-label"
        rowspan="2"
        colspan="3"
        style="padding-top: 35px"
      >
        {{ $t('production.hands_numbers') }}
      </td>
      <td class="text-center custom-header-label" colspan="2">
        {{ $t('production.calibration') }}(*)
      </td>
      <td class="text-center custom-header-label" colspan="4">
        {{ $t('production.large') }} (cm)
      </td>
      <td
        class="text-center custom-header-label"
        rowspan="2"
        style="padding-top: 35px"
      >
        {{ $t('production.fingers_total') }}
      </td>
      <td
        class="text-center custom-header-label"
        rowspan="2"
        style="padding-top: 35px"
      >
        % {{ $t('common_words.shrinkage') }}
      </td>
      <td
        class="text-center custom-header-label"
        rowspan="2"
        style="padding-top: 35px"
      >
        {{ $t('production.ratio') }}
      </td>
    </tr>
    <tr class="cusmtom-thead-color">
      <td class="text-center custom-header-label" colspan="3">
        {{ $t('production.net') }}
      </td>
      <td class="text-center custom-header-label" style="width: 5%">
        {{ $t('production.stem') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('production.second_hand') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('production.last_hand') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('production.second_hand') }}
      </td>
      <td class="text-center custom-header-label" colspan="3">
        {{ $t('production.last_hand') }}
      </td>
    </tr>
    <tr class="cusmtom-thead-color">
      <td class="text-center custom-header-label" style="width: 5%">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.maximum') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.minimum') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.maximum') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.minimum') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.maximum') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.minimum') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
      <td class="text-center custom-header-label">
        {{ $t('common_words.average') }}
      </td>
    </tr>
  </thead>
</template>
<script>
export default {
  name: 'thead-consolidated',
};
</script>
